import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { State } from "../../State";
import GestureHandler from "./GestureHandler";
import RotationGestureDetector from "../detectors/RotationGestureDetector";
var ROTATION_RECOGNITION_THRESHOLD = Math.PI / 36;
var RotationGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(RotationGestureHandler, GestureHandler);
    var _super = _create_super(RotationGestureHandler);
    function RotationGestureHandler() {
        _class_call_check(this, RotationGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "rotation", 0);
        _define_property(_assert_this_initialized(_this), "velocity", 0);
        _define_property(_assert_this_initialized(_this), "cachedAnchorX", 0);
        _define_property(_assert_this_initialized(_this), "cachedAnchorY", 0);
        _define_property(_assert_this_initialized(_this), "rotationGestureListener", {
            onRotationBegin: function(_detector) {
                return true;
            },
            onRotation: function(detector) {
                var previousRotation = _this.rotation;
                _this.rotation += detector.getRotation();
                var delta = detector.getTimeDelta();
                if (delta > 0) {
                    _this.velocity = (_this.rotation - previousRotation) / delta;
                }
                if (Math.abs(_this.rotation) >= ROTATION_RECOGNITION_THRESHOLD && _this.currentState === State.BEGAN) {
                    _this.activate();
                }
                return true;
            },
            onRotationEnd: function(_detector) {
                _this.end();
            }
        });
        _define_property(_assert_this_initialized(_this), "rotationGestureDetector", new RotationGestureDetector(_this.rotationGestureListener));
        return _this;
    }
    _create_class(RotationGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(RotationGestureHandler.prototype), "init", this).call(this, ref, propsRef);
                this.setShouldCancelWhenOutside(false);
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                _get(_get_prototype_of(RotationGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
            }
        },
        {
            key: "transformNativeEvent",
            value: function transformNativeEvent() {
                return {
                    rotation: this.rotation ? this.rotation : 0,
                    anchorX: this.getAnchorX(),
                    anchorY: this.getAnchorY(),
                    velocity: this.velocity ? this.velocity : 0
                };
            }
        },
        {
            key: "getAnchorX",
            value: function getAnchorX() {
                var anchorX = this.rotationGestureDetector.getAnchorX();
                return anchorX ? anchorX : this.cachedAnchorX;
            }
        },
        {
            key: "getAnchorY",
            value: function getAnchorY() {
                var anchorY = this.rotationGestureDetector.getAnchorY();
                return anchorY ? anchorY : this.cachedAnchorY;
            }
        },
        {
            key: "onPointerDown",
            value: function onPointerDown(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(RotationGestureHandler.prototype), "onPointerDown", this).call(this, event);
            }
        },
        {
            key: "onPointerAdd",
            value: function onPointerAdd(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(RotationGestureHandler.prototype), "onPointerAdd", this).call(this, event);
                this.tryBegin();
                this.rotationGestureDetector.onTouchEvent(event, this.tracker);
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                if (this.tracker.getTrackedPointersCount() < 2) {
                    return;
                }
                if (this.getAnchorX()) {
                    this.cachedAnchorX = this.getAnchorX();
                }
                if (this.getAnchorY()) {
                    this.cachedAnchorY = this.getAnchorY();
                }
                this.tracker.track(event);
                this.rotationGestureDetector.onTouchEvent(event, this.tracker);
                _get(_get_prototype_of(RotationGestureHandler.prototype), "onPointerMove", this).call(this, event);
            }
        },
        {
            key: "onPointerOutOfBounds",
            value: function onPointerOutOfBounds(event) {
                if (this.tracker.getTrackedPointersCount() < 2) {
                    return;
                }
                if (this.getAnchorX()) {
                    this.cachedAnchorX = this.getAnchorX();
                }
                if (this.getAnchorY()) {
                    this.cachedAnchorY = this.getAnchorY();
                }
                this.tracker.track(event);
                this.rotationGestureDetector.onTouchEvent(event, this.tracker);
                _get(_get_prototype_of(RotationGestureHandler.prototype), "onPointerOutOfBounds", this).call(this, event);
            }
        },
        {
            key: "onPointerUp",
            value: function onPointerUp(event) {
                _get(_get_prototype_of(RotationGestureHandler.prototype), "onPointerUp", this).call(this, event);
                this.tracker.removeFromTracker(event.pointerId);
                this.rotationGestureDetector.onTouchEvent(event, this.tracker);
                if (this.currentState !== State.ACTIVE) {
                    return;
                }
                if (this.currentState === State.ACTIVE) {
                    this.end();
                } else {
                    this.fail();
                }
            }
        },
        {
            key: "onPointerRemove",
            value: function onPointerRemove(event) {
                _get(_get_prototype_of(RotationGestureHandler.prototype), "onPointerRemove", this).call(this, event);
                this.rotationGestureDetector.onTouchEvent(event, this.tracker);
                this.tracker.removeFromTracker(event.pointerId);
            }
        },
        {
            key: "tryBegin",
            value: function tryBegin() {
                if (this.currentState !== State.UNDETERMINED) {
                    return;
                }
                this.begin();
            }
        },
        {
            key: "activate",
            value: function activate(_force) {
                _get(_get_prototype_of(RotationGestureHandler.prototype), "activate", this).call(this);
            }
        },
        {
            key: "onReset",
            value: function onReset() {
                if (this.currentState === State.ACTIVE) {
                    return;
                }
                this.rotation = 0;
                this.velocity = 0;
                this.rotationGestureDetector.reset();
            }
        }
    ]);
    return RotationGestureHandler;
}(GestureHandler);
export { RotationGestureHandler as default };
